module.exports = __webpack_public_path__ + "img/case13-中国石油.dbfe4b96.png";